import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DeliveryList = () => {
  const [deliveries, setDeliveries] = useState([]);
  const [filters, setFilters] = useState({
    date: '',
    DeliveryPersonID: '',
    Address: '',
    HallID: ''
  });
  const [halls, setHalls] = useState([]);
  const [emp, setEmp] = useState([]);
  const [searched, setSearched] = useState(false);

  const getchalls = async () => {
    try {
      const { data } = await axios.get('https://suhba.education.com.ly/back/api/getchalls');
      setHalls(data.HallName); // Assuming data is an array of halls
    } catch (error) {
      console.error('Error fetching halls:', error);
    }
  };

  const getEmp = async () => {
    try {
      const { data } = await axios.get('https://suhba.education.com.ly/back/api/getEmp');
      setEmp(data);
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };

  useEffect(() => {
    getEmp();
    getchalls();
  }, []);

  const fetchDeliveries = async () => {
    try {
      const response = await axios.get('https://suhba.education.com.ly/back/api/deliveries', {
        params: filters
      });
      setDeliveries(response.data);
    } catch (error) {
      console.error('Error fetching deliveries:', error);
    }
  };

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
    setSearched(true);
    fetchDeliveries();
  };

  const handleClear = () => {
    setFilters({ date: '', Address: '', DeliveryPersonID: '', HallID: '' });
    setDeliveries([]);
    setSearched(false);
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <div className="tbl-caption">
              <h4 className="heading ms-3">تفاصيل التوصيل</h4>
            </div>

            {/* Filter Form */}
            <div className="row m-3">
              <div className="col-xl-12">
                <div className="row align-items-end">

                  <div className="col-xl-2 mb-2">
                    <label className="form-label">تاريخ التوصيل</label>
                    <input className="form-control" type="date" name="date" onChange={handleChange} value={filters.date} />
                  </div>

                  <div className="col-xl-2 mb-2">
                    <label className="form-label">العنوان</label>
                    <input className="form-control" type="text" name="Address" placeholder="العنوان" onChange={handleChange} value={filters.Address} />
                  </div>

                  <div className="col-xl-2 mb-2">
                    <label className="form-label">المندوب</label>
                    <select className="form-control" name="DeliveryPersonID" onChange={handleChange} value={filters.DeliveryPersonID}>
                      <option value="">اختر من القائمة</option>
                      {emp.map((row) => (
                        <option key={row.EmployeeID} value={row.EmployeeID}>
                          {row.FirstName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-xl-2 mb-2">
                    <label className="form-label">قاعة الأفراح</label>
                    <select className="form-control" name="HallID" onChange={handleChange} value={filters.HallID}>
                      <option value="">اختر من القائمة</option>
                      {halls.map((row) => (
                        <option key={row.HallID} value={row.HallID}>
                          {row.HallName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-xl-2 mb-2 d-flex align-items-end">
                    <button className="btn btn-primary w-100" onClick={handleSearch}>
                      بحث
                    </button>
                  </div>

                  <div className="col-xl-2 mb-2 d-flex align-items-end">
                    <button className="btn btn-secondary w-100" onClick={handleClear}>
                      إلغاء 
                    </button>
                  </div>

                </div>
              </div>
            </div>

            {/* Delivery Table */}
            <div style={{ overflowX: 'auto', maxHeight: '400px' }} className="table-responsive table-bordered m-3" id="invoiceDiv">
              <table className="table table-bordered text-center" dir="rtl" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ position: 'sticky', top: 0, backgroundColor: 'rgba(147, 128, 204, 1)', zIndex: 2, color: 'white' }}>
                  <tr>
                    <th>التاريخ</th>
                    <th>الوقت</th>
                    <th>العنوان</th>
                    <th>الموصل</th>
                    <th>القاعة</th>
                  </tr>
                </thead>
                <tbody>
                  {!searched ? (
                    <tr>
                      <td colSpan="5">يرجى استخدام الفلاتر للبحث</td>
                    </tr>
                  ) : deliveries.length === 0 ? (
                    <tr>
                      <td colSpan="5">لا توجد بيانات للعرض</td>
                    </tr>
                  ) : (
                    deliveries.map((order) => (
                      <tr key={order.id}>
                        <td>{order.DeliveryDate}</td>
                        <td>{order.DeliveryTime}</td>
                        <td>{order.Address}</td>
                        <td>{order.delivery_person?.FirstName || 'غير متوفر'}</td>
                        <td>{order.wedding_hall?.HallName || 'غير متوفر'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryList;
